export const pathsWithRequiredParams = {
    "/admin/shipments/view": ["shipmentId"],
};
